import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { InfoOutlinedIcon } from "src/lib/ui-icon-v2";
import React, { Fragment, type ReactNode } from "react";
import * as styles from "./InputLabel.styles.ts";

export const InputLabel = ({
  label,
  id,
  required,
  helperText,
  additionalElems,
}: {
  label: ReactNode;
  helperText?: ReactNode;
  id?: string;
  required?: boolean;
  additionalElems?: ReactNode[];
}) => {
  return (
    <div css={styles.container}>
      <div>
        <label css={styles.label} htmlFor={id}>
          {label}
        </label>
        {required && <span css={styles.requiredIndicator}>*</span>}
      </div>

      {helperText && (
        <TooltipV2 cursor={"help"} content={helperText}>
          <InfoOutlinedIcon />
        </TooltipV2>
      )}

      <div css={styles.additionalElems}>
        {additionalElems?.map((elem, i) => <Fragment key={i}>{elem}</Fragment>)}
      </div>
    </div>
  );
};
